import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { Suggestion } from '../../store/types';
import ConditionLine from './primitives/conditions-code-diff';
import PatchCard from './primitives/patch-card';
import SetValueRow, { ValueChip } from './primitives/set-value-row';
type GhostRulesGroupProps = {
  suggestion: Suggestion;
};
const GhostRulesGroup = t0 => {
  const $ = _c(15);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.group"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  if (suggestion.operation.kind !== "add_rules_group") {
    return null;
  }
  const group = suggestion.operation.group;
  const t2 = suggestion.id;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !suggestion.canApply;
  let t5;
  if ($[3] !== group.value) {
    t5 = <SetValueRow><ValueChip value={group.value} /></SetValueRow>;
    $[3] = group.value;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== group.conditions) {
    t6 = group.conditions.map(_temp2);
    $[5] = group.conditions;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t6}</div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== suggestion.id || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <PatchCard suggestionId={t2} note={t3} isStale={t4}>{t5}{t7}</PatchCard>;
    $[9] = suggestion.id;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default GhostRulesGroup;
function _temp($) {
  return $.add;
}
function _temp2(c, i) {
  return <ConditionLine key={c.id} prefix={i === 0 ? "if" : "or"} expression={c.expression} />;
}